class ProductDescription extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    if (!this?.els?.trigger?.exists) return

    this.handleClick = this.handleClick.bind(this)

    this.listeners.add(this.els.trigger.element, 'click', this.handleClick)
  }

  handleClick () {
    const description = this.els.description?.element
    const externalDescription = this.externalEls.description?.element

    if (description && window.BAO.MediaBreakpoints.isMd === false) {
      description.scrollIntoView({ behavior: 'smooth' })
    } else if (
      externalDescription &&
      this.dataset.scrollExternalTargetIntoView === 'true'
    ) {
      externalDescription.scrollIntoView({ behavior: 'smooth' })
    }
  }
}

if (!customElements.get('product-description')) {
  customElements.define('product-description', ProductDescription)
}
